import React from 'react';

import StepItem from '../StepItem/StepItem';

const StepsContentSection = ({ groupFormData, setGroupFormData = () => {}, isEditable }) => {
    if (!groupFormData || groupFormData.length === 0) return null;

    return (
        <ul className="flex flex-col gap-2.5">
            {groupFormData.map((step) => {
                const { name, order } = step;

                return (
                    <StepItem
                        key={name + order}
                        step={step}
                        isEditable={isEditable}
                        setGroupFormData={setGroupFormData}
                    />
                );
            })}
        </ul>
    );
};

export default StepsContentSection;
